(function () {
  var dialog = document.querySelector('[data-fp-inspiration-lightbox]');
  if (!dialog) return;

  var imageEl = dialog.querySelector('[data-fp-inspiration-image]');
  var captionEl = dialog.querySelector('[data-fp-inspiration-caption]');
  var closeBtn = dialog.querySelector('[data-fp-inspiration-close]');
  var prevBtn = dialog.querySelector('[data-fp-inspiration-prev]');
  var nextBtn = dialog.querySelector('[data-fp-inspiration-next]');
  var triggers = [];
  var index = 0;
  var lastFocus = null;

  function collectTriggers() {
    triggers = Array.prototype.slice.call(document.querySelectorAll('[data-fp-inspiration-open]'));
  }

  function isRtl() {
    return document.documentElement.getAttribute('dir') === 'rtl';
  }

  function render() {
    var trigger = triggers[index];
    if (!trigger || !imageEl) return;
    imageEl.src = trigger.getAttribute('data-src') || '';
    imageEl.alt = trigger.getAttribute('data-alt') || '';
    var caption = trigger.getAttribute('data-caption') || '';
    if (captionEl) {
      captionEl.textContent = caption;
      captionEl.hidden = caption === '';
    }
    if (prevBtn) prevBtn.disabled = triggers.length < 2;
    if (nextBtn) nextBtn.disabled = triggers.length < 2;
  }

  function openAt(i) {
    collectTriggers();
    if (!triggers.length) return;
    index = (i + triggers.length) % triggers.length;
    lastFocus = document.activeElement;
    render();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('fp-inspiration-lightbox-open');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('fp-inspiration-lightbox-open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function step(delta) {
    collectTriggers();
    if (triggers.length < 2) return;
    index = (index + delta + triggers.length) % triggers.length;
    render();
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-fp-inspiration-open]');
    if (trigger) {
      event.preventDefault();
      collectTriggers();
      openAt(triggers.indexOf(trigger));
      return;
    }
    if (event.target.closest('[data-fp-inspiration-close]')) {
      closeLightbox();
      return;
    }
    if (event.target.closest('[data-fp-inspiration-prev]')) {
      step(-1);
      return;
    }
    if (event.target.closest('[data-fp-inspiration-next]')) {
      step(1);
    }
  });

  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeLightbox();
  });

  document.addEventListener('keydown', function (event) {
    if (!dialog.open) return;
    if (event.key === 'Escape') {
      closeLightbox();
      return;
    }
    if (event.key === 'ArrowLeft') {
      step(isRtl() ? 1 : -1);
    } else if (event.key === 'ArrowRight') {
      step(isRtl() ? -1 : 1);
    }
  });

  collectTriggers();
})();
